import React from 'react';
import { Grid } from '@mui/material';
import { BoardNodeShimmer } from 'components/SparkRuns/SparkRunningProgressScreen';
import BoardNodeContainer from 'components/common/SparkOutputBoard/BoardNodeContainer';
import { useBoardNodeTypes } from 'hooks/EntityTypes/useBoardNodeTypes';
import type { BoardNodes } from 'types/BoardNode';

type BoardListViewContainerProps = {
  isParentLoading?: boolean;
  boardNodes?: BoardNodes[];
};

function SparkRunResultsBoardListViewContainer({
  isParentLoading = false,
  boardNodes,
}: BoardListViewContainerProps) {
  const { idMap: boardNodeTypesIdMap } = useBoardNodeTypes();
  const isLoading = isParentLoading;

  if (isLoading) {
    return (
      <Grid container gap={2}>
        {boardNodes?.map((boardNode, index) => (
          <BoardNodeShimmer
            title={boardNode.attributes.title}
            id={boardNode.id}
            key={`board-node-shimmer-${index}`}
            animate={true}
            index={index}
          />
        ))}
      </Grid>
    );
  }

  return (
    <Grid container style={{ width: '100%', height: '100%' }} gap={2}>
      {boardNodes?.map((boardNode) => (
        <BoardNodeContainer
          boardNode={boardNode}
          readOnly={true}
          isCanvasView={false}
          isHover={false}
          shouldResolveReference={false}
          nodeType={boardNodeTypesIdMap?.[boardNode.attributes.boardNodeTypeID]}
          containerProps={{
            border: '1px solid #e0e0e0',
            height: 'fit-content',
          }}
        />
      ))}
    </Grid>
  );
}

// Memoize the component to avoid unnecessary re-renders
export default React.memo(SparkRunResultsBoardListViewContainer);
